import EventEmitter from 'src/helpers/EventEmitter'

const Events = {
  START: 'touchstart',
  MOVE: 'touchmove',
  END: 'touchend',
}

class Touch {
  constructor(el) {
    Object.assign(this, EventEmitter)
    this.el = el
    this.x = null
    this.y = null
    this.touching = false
    this.listening = false
    this.listen()
  }

  _onTouchStart = (evt) => {
    window.addEventListener('mousemove', this._onTouchMove)
    window.addEventListener('touchmove', this._onTouchMove)
    window.addEventListener('mouseup', this._onTouchEnd)
    window.addEventListener('touchend', this._onTouchEnd)
    let ev = evt.touches && evt.touches[0] ? evt.touches[0] : evt
    this.x = ev.pageX / window.innerWidth - 0.5
    this.y = ev.pageY / window.innerHeight - 0.5
    this.touching = true
    this.emit(Events.START, { x: this.x, y: this.y })
  }

  _onTouchMove = (evt) => {
    let ev = evt.touches && evt.touches[0] ? evt.touches[0] : evt
    let x = ev.pageX / window.innerWidth - 0.5
    let y = ev.pageY / window.innerHeight - 0.5
    let diff = {
      x: (x - this.x) * window.innerWidth,
      y: (y - this.y) * window.innerHeight,
    }
    this.x = x
    this.y = y
    this.emit(Events.MOVE, { x: this.x, y: this.y, diff })
  }

  _onTouchEnd = () => {
    window.removeEventListener('mousemove', this._onTouchMove)
    window.removeEventListener('touchmove', this._onTouchMove)
    window.removeEventListener('mouseup', this._onTouchEnd)
    window.removeEventListener('touchend', this._onTouchEnd)
    this.touching = false
    this.emit(Events.END, { x: this.x, y: this.y })
  }

  listen() {
    if (this.listening) return
    this.listening = true
    this.el.addEventListener('mousedown', this._onTouchStart)
    this.el.addEventListener('touchstart', this._onTouchStart)
  }

  unlisten() {
    if (!this.listening) return
    this.listening = false
    this.touching = false
    this.el.removeEventListener('mousedown', this._onTouchStart)
    this.el.removeEventListener('touchstart', this._onTouchStart)
    window.removeEventListener('mousemove', this._onTouchMove)
    window.removeEventListener('touchmove', this._onTouchMove)
    window.removeEventListener('mouseup', this._onTouchEnd)
    window.removeEventListener('touchend', this._onTouchEnd)
  }

  destroy() {
    this.unlisten()
    this.el = null
    this.x = null
    this.y = null
    this.touching = null
    this.listening = null
  }
}

Touch.Events = Events

export default Touch
